module.exports = __webpack_public_path__ + "img/calendar.107d8c1a.svg";